export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client && document) {
    const url = useRequestURL();
    if (to.path === from.path) {
      to.meta.referrer = from.meta.referrer ? url.href : document.referrer;
    } else {
      to.meta.referrer = url.href;
    }
  }
});
